<app-container>
  <mat-card>
    <mat-card-content>
      <h1 class="text-center">Forgot Password</h1>
      <form
        [formGroup]="form"
        (ngSubmit)="submitForgotPassword()"
        mat-card-content
        *ngIf="!passwordReset; else passwordResetSuccess"
      >
        <div class="grid gap-md w-1/2 mx-auto m-1xl">
          <div>
            <label>Email Address</label>
            <mat-form-field class="w-full">
              <input
                matInput
                type="email"
                autocomplete="email"
                aria-describedby="emailHelp"
                placeholder="Email"
                formControlName="email"
              />
            </mat-form-field>
          </div>

          <div class="form-group text-center mt-5">
            <button class="btn btn-primary">Send a Reset Link</button>
          </div>
        </div>
      </form>
      <ng-template #passwordResetSuccess>
        <div class="grid gap-md w-1/2 mx-auto m-1xl text-center">
          <p>An email with password reset instructions has been sent to {{ form.value.email }}.</p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</app-container>
